import React from "react";

import BaseApp from "@apps/base/BaseApp";
import {createRoot} from "react-dom/client";
import {BrowserRouter, Route, Routes} from "react-router-dom";

import {setConsumerHeader} from "@globals/utils/setConsumerHeader";

import BrandApp from "./BrandApp";

setConsumerHeader();

const root = createRoot(document.getElementById("root")!);

root.render(
  <BaseApp includeHeader={false}>
    <BrowserRouter basename="/brand/">
      <Routes>
        <Route path="/:operatorSlug/:restaurantSlug" element={<BrandApp />} />
        <Route path="*" element={<BrandApp />} />
      </Routes>
    </BrowserRouter>
  </BaseApp>
);
